import React from "react";
import Comingsoonpage from "../../../common/Comingsoon";

const Calendar = () => {
  return <div><Comingsoonpage /></div>;
};

export default Calendar;